import { appendContent } from './doc-append-content'
import { createAvailableFileElement } from './common/elements'
import { createModal } from './create-modal'
import { showErrors } from './open-error-modal'

const getStyles = async (context: Word.RequestContext, window) => {
    const styles = context.document.getStyles()
    styles.load({nameLocal: true})
    await context.sync()
    return styles.items.map(style => style.nameLocal)
}

export const openModal = async (context: Word.RequestContext, window, options: {
    files: Array<string>
    oldFiles?: Array<string>
    inited?: boolean
}) => {
    const styles = await getStyles(context, window)
    const {command, modalWindow} = await createModal(context, window, {
        url: 'modal.html',
        handler: (command, modalWindow, message) => {
            if (message.type == 'inited') {
                if (options.inited)
                    command('onFilesAvailable', {files: options.files, styles, oldFiles: options.oldFiles})
                else
                    command('onPluginMessage', {files: options.files})
            }
            if (message.type == 'addFile') {
                createAvailableFileElement(message.filename)
            }
            if (message.type == 'addParagraphs') {
                appendContent(context, message as any)
            }
            if (message.type == 'onError') {
                modalWindow.close()
                showErrors(context, window, message.messages)
            }
            if (message.type == 'preview') {
                modalWindow.close()
                openModal(context, window, {
                    files: message.files,
                    oldFiles: message.oldFiles,
                    inited: true,
                })
            }
        },
    })
    return {
        modalWindow,
        command,
        styles,
    }
}
